import React from 'react'
import styled from 'styled-components'
import {ButtonSecondary, UploadFileIcon, Col} from '@modifi/ui'
import {UploadPartnerIntegrations} from '@modifi/plugin-documents'
import {DocumentType} from '@modifi/enums'
import {useTranslation} from '@modifi/plugin-i18n'
import {useCountrySpecificTranslationKey} from '@modifi/plugin-onboarding'

const StyledButtonSecondary = styled(ButtonSecondary)`
  margin-right: 24px !important;
`

type DocumentTypeActionsColProps = {
  onPartnerFileSelection: (files: FileList | File[]) => void
  documentType: string
  isDisabled?: boolean
  multiple?: boolean
  className?: string
}

const DocumentTypeActionsCol = React.forwardRef<HTMLButtonElement, DocumentTypeActionsColProps>(
  (
    {documentType, onPartnerFileSelection, isDisabled = false, multiple = false, className},
    ref
  ) => {
    const countrySpecificKey = useCountrySpecificTranslationKey()
    const {t} = useTranslation('charon')

    return (
      <Col auto pt={4} className={className} mb={16}>
        <StyledButtonSecondary
          active={!isDisabled}
          icon
          type="button"
          ref={ref}
          data-target="upload-document"
        >
          <UploadFileIcon height={16} width={16} />
          <span>{t(countrySpecificKey('document-upload.label'))}</span>
        </StyledButtonSecondary>
        <UploadPartnerIntegrations
          onPartnerFileSelection={onPartnerFileSelection}
          documentType={documentType as DocumentType}
          active={!isDisabled}
          multiple={multiple}
        />
      </Col>
    )
  }
)

export default DocumentTypeActionsCol
